<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Minhas Responsabilidades</h2>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <ng-container *ngFor="let itens of list">
            <div *ngIf="itens[0]?.type == 'projeto'">
              <div class="info-page">
                <h3>Projeto {{ itens[0]?.code }} - {{itens[0]?.title}}</h3>
              </div>
              <!-- Lista projetos -->
              <div class="system-table table-container system-table-m-b">
                <div class="system-table-conteiner">
                  <table>
                    <thead>
                      <tr>
                        <th class="text-center width5">Código</th>
                        <th class="width25">Projeto</th>
                        <th class="text-center">Status Gerente</th>
                        <th class="text-center">Última Atualização</th>
                        <th class="text-center">Responsabilidade</th>
                        <th class="text-center">
                          <div>Titular</div> (Ações Corretivas)
                        </th>
                        <th class="text-center">
                          <div>Adjunto</div> (Ações Corretivas)
                        </th>
                        <th class="text-center width5">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container>
                        <tr>
                          <td class="title text-center">{{ itens[0]?.code }}</td>
                          <td>
                            {{itens[0]?.title}}
                            <div class="responsavel">
                              <div *ngIf="itens[0]?.level_priority" class="tag">Estratégico</div>
                            </div>
                          </td>
                          <td class="status">
                            <div *ngIf="itens[0]?.geral_analysis_status1">
                              <span [innerHTML]="itens[0]?.geral_analysis_status1"></span>
                            </div>
                          </td>
                          <td class="text-center">
                            {{ itens[0]?.geral_analysis_ctr_dth_atu }}
                          </td>
                          <td class="text-center">
                            {{ itens[0]?.pf_manager_status }}
                          </td>
                          <td class="text-center">
                            {{ itens[0]?.pf_critical_action_manager_main }}
                          </td>
                          <td class="text-center">
                            {{ itens[0]?.pf_critical_action_manager_adjunct }}
                          </td>
                          <td>
                            <div class="btn-icon">
                              <a class="icon-table" [routerLink]="viewProjeto(itens[0]?.id)">
                                <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                              </a>
                              <span class="icon-table" (click)="itens[0].viewActive = !itens[0]?.viewActive" *ngIf="itens[0]?.pontoCriticoList?.length">
                                <img src="assets/images/svgs/arrows-{{itens[0].viewActive ? 'close' : 'open'}}.svg" alt="Situação" [tooltip]="itens[0]?.viewActive ? 'Ocultar situação' : 'Mostrar situação'" placement="bottom">
                              </span>
                            </div>
                          </td>
                        </tr>

                        <ng-container *ngIf="itens[0]?.viewActive && itens[0]?.pontoCriticoList?.length">
                          <tr>
                            <th class="title" colspan="2">Ponto Crítico</th>
                            <th colspan="2">Ação Corretiva</th>
                            <th class="text-center">Prazo</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Última Atualização</th>
                            <th class="text-center">Responsavel</th>
                          </tr>
                          <ng-container *ngFor="let ponto of itens[0]?.pontoCriticoList">
                            <tr>
                              <td class="title">{{ponto?.description}}</td>
                              <td>{{ponto?.title}}</td>
                              <td class="text-center">{{ ponto?.deadline }}</td>
                              <td class="status">
                                <div [innerHTML]="ponto?.status1"></div>
                              </td>
                              <td class="text-center">{{ ponto?.ctr_dth_atu }}</td>
                              <td class="text-center">{{ ponto?.pf_manager_status }}</td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Lista indicadores -->
            <div *ngIf="itens?.indicadores">
              <div class="info-page">
                <h3>Projeto {{ itens?.indicadores?.[0]?.project_code }} - {{itens?.indicadores?.[0]?.project_title}}</h3>
              </div>
              <div class="form-group row m-b" *ngIf="indYears[itens?.indicadores?.[0]?.pf_id]?.years?.length">
                <div class="col-sm-4">
                  <label class="col-sm-12 pb-1">Ano:</label>
                  <ng-select id="year" class="ng-select-alternative" [items]="indYears[itens?.indicadores?.[0]?.pf_id]?.years" [(ngModel)]="indYears[itens?.indicadores?.[0]?.pf_id].id" placeholder="Selecione o Ano" [clearable]="false">
                  </ng-select>
                </div>
              </div>

              <div class="system-table table-container system-table-m-b">
                <div class="system-table-conteiner">
                  <table>
                    <thead>
                      <tr>
                        <th class="text-center width5">Código</th>
                        <th class="width25">Indicadores</th>
                        <th class="text-center">Status</th>
                        <th class="text-center">Mês/Ano Apurado</th>
                        <th class="text-center">Responsabilidade</th>
                        <th class="text-center">
                          <div>Titular</div> (Plano de ação)
                        </th>
                        <th class="text-center">
                          <div>Adjunto</div> (Plano de ação)
                        </th>
                        <th class="text-center">
                          <div>Titular</div> (Ações Corretivas)
                        </th>
                        <th class="text-center">
                          <div>Adjunto</div> (Ações Corretivas)
                        </th>
                        <th class="text-center width5">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let indicadores of itens?.indicadores">
                        <tr *ngIf="indicadores?.ind_goal_year == indYears[itens?.indicadores?.[0]?.pf_id].id">
                          <td class="title text-center">{{ indicadores?.code }}</td>
                          <td>
                            {{indicadores?.title}}
                            <div class="responsavel">
                              <div *ngIf="indicadores?.level_priority" class="tag">Estratégico</div>
                            </div>
                          </td>
                          <td class="status">
                            <div *ngIf="indicadores?.geral_analysis_status1">
                              <span [innerHTML]="indicadores?.geral_analysis_status1"></span>
                            </div>
                          </td>
                          <td class="text-center">
                            {{ indicadores?.ind_goal_month }}
                          </td>
                          <td class="text-center">
                            {{ indicadores?.pf_manager_status }}
                          </td>
                          <td class="text-center">
                            {{ indicadores?.pf_action_manager_main }}
                          </td>
                          <td class="text-center">
                            {{ indicadores?.pf_action_manager_adjunct }}
                          </td>
                          <td class="text-center">
                            {{ indicadores?.pf_critical_action_manager_main }}
                          </td>
                          <td class="text-center">
                            {{ indicadores?.pf_critical_action_manager_adjunct }}
                          </td>
                          <td>
                            <div class="btn-icon">
                              <a class="icon-table" [routerLink]="viewIndicador(indicadores)">
                                <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                              </a>
                              <span class="icon-table" (click)="indicadores.viewActive = !indicadores?.viewActive" *ngIf="indicadores?.pontoCriticoList?.length">
                                <img src="assets/images/svgs/arrows-{{indicadores.viewActive ? 'close' : 'open'}}.svg" alt="Situação" [tooltip]="indicadores?.viewActive ? 'Ocultar situação' : 'Mostrar situação'" placement="bottom">
                              </span>
                            </div>
                          </td>
                        </tr>

                        <ng-container *ngIf="indicadores?.viewActive && indicadores?.pontoCriticoList?.length">
                          <tr>
                            <th class="title" colspan="3">Ponto Crítico</th>
                            <th colspan="3">Ação Corretiva</th>
                            <th class="text-center">Prazo</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Última Atualização</th>
                            <th class="text-center">Responsavel</th>
                          </tr>
                          <ng-container *ngFor="let pontoIndicador of indicadores?.pontoCriticoList">
                            <tr>
                              <td class="title" colspan="3">{{pontoIndicador?.description}}</td>
                              <td colspan="3">{{pontoIndicador?.title}}</td>
                              <td class="text-center">{{ pontoIndicador?.deadline }}</td>
                              <td class="status">
                                <div [innerHTML]="pontoIndicador?.status1"></div>
                              </td>
                              <td class="text-center">{{ pontoIndicador?.ctr_dth_atu }}</td>
                              <td class="text-center">{{ pontoIndicador?.pf_manager_status }}</td>
                            </tr>
                          </ng-container>
                        </ng-container>

                        <ng-container *ngIf="indicadores?.viewActive && indicadores?.actionList?.length">
                          <tr>
                            <th class="title" colspan="6">Ação</th>
                            <th class="text-center">Prazo</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Última Atualização</th>
                            <th class="text-center">Responsavel</th>
                          </tr>
                          <ng-container *ngFor="let pontoIndicador of indicadores?.actionList">
                            <tr>
                              <td class="title" colspan="6">{{pontoIndicador?.title}}</td>
                              <td class="text-center">{{ pontoIndicador?.deadline }}</td>
                              <td class="status">
                                <div [innerHTML]="pontoIndicador?.status1"></div>
                              </td>
                              <td class="text-center">{{ pontoIndicador?.ctr_dth_atu }}</td>
                              <td class="text-center">{{ pontoIndicador?.pf_manager_status }}</td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Lista entregas -->
            <div class="system-table table-container system-table-m-b" *ngIf="itens?.entregas">
              <div class="system-table-conteiner">
                <table>
                  <thead>
                    <tr>
                      <th class="text-center width5">Código</th>
                      <th class="width25">Entrega</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Última Atualização</th>
                      <th class="text-center">Responsabilidade</th>
                      <th class="text-center">
                        <div>Titular</div> (Ações Corretivas)
                      </th>
                      <th class="text-center">
                        <div>Adjunto</div> (Ações Corretivas)
                      </th>
                      <th class="text-center width5">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let entrega of itens?.entregas">
                      <tr>
                        <td class="title text-center">{{ entrega?.code }}</td>
                        <td>
                          {{entrega?.title}}
                          <div class="responsavel">
                            <div *ngIf="entrega?.level_priority" class="tag">Estratégico</div>
                          </div>
                        </td>
                        <td class="status">
                          <div *ngIf="entrega?.geral_analysis_status1">
                            <span [innerHTML]="entrega?.geral_analysis_status1"></span>
                          </div>
                        </td>
                        <td class="text-center">
                          {{ entrega?.geral_analysis_ctr_dth_atu }}
                        </td>
                        <td class="text-center">
                          {{ entrega?.pf_manager_status }}
                        </td>
                        <td class="text-center">
                          {{ entrega?.pf_critical_action_manager_main }}
                        </td>
                        <td class="text-center">
                          {{ entrega?.pf_critical_action_manager_adjunct }}
                        </td>
                        <td>
                          <div class="btn-icon">
                            <a class="icon-table" [routerLink]="viewEntregas(entrega)">
                              <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                            </a>
                            <span class="icon-table" (click)="entrega.viewActive = !entrega?.viewActive" *ngIf="entrega?.pontoCriticoList?.length">
                              <img src="assets/images/svgs/arrows-{{entrega.viewActive ? 'close' : 'open'}}.svg" alt="Situação" [tooltip]="entrega?.viewActive ? 'Ocultar situação' : 'Mostrar situação'" placement="bottom">
                            </span>
                          </div>
                        </td>
                      </tr>

                      <ng-container *ngIf="entrega?.viewActive && entrega?.pontoCriticoList?.length">
                        <tr>
                          <th class="title" colspan="2">Ponto Crítico</th>
                          <th colspan="2">Ação Corretiva</th>
                          <th class="text-center">Prazo</th>
                          <th class="text-center">Status</th>
                          <th class="text-center">Última Atualização</th>
                          <th class="text-center">Responsavel</th>
                        </tr>
                        <ng-container *ngFor="let ponto of entrega?.pontoCriticoList">
                          <tr>
                            <td class="title">{{ponto?.description}}</td>
                            <td>{{ponto?.title}}</td>
                            <td class="text-center">{{ ponto?.deadline }}</td>
                            <td class="status">
                              <div [innerHTML]="ponto?.status1"></div>
                            </td>
                            <td class="text-center">{{ ponto?.ctr_dth_atu }}</td>
                            <td class="text-center">{{ ponto?.pf_manager_status }}</td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
          <div class="text-center" *ngIf="list?.length == 0">
            <h3>Você não tem nenhuma responsabilidade pendente</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>